export default __webpack_public_path__ + "static/media/mist.0e5f7c45.svg";